//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wcs from '@/scripts/libs/wcs'
import { WcsLocales } from '@/scripts/libs/wcs/types/locales'
import { KLARNA, AFTERPAY, PAYPAL } from '@/scripts/constants/pay-over-time'
const {
  payOverTime: { afterpay, klarna, payPal },
  locale,
} = wcs.getStoreConfig()

export default {
  name: 'rb-pay-over-time-content',
  props: {
    isModal: Boolean,
    prices: {
      type: Object,
      default: () => ({
        discountedPrice: undefined,
        listPrice: '',
        promo: undefined,
        priceFormat: '',
        currencySymbol: '',
      }),
    },
  },
  data() {
    return {
      KLARNA,
      PAYPAL,
      AFTERPAY,
    }
  },
  computed: {
    payPalLaterDescription() {
      const payPalIsEnabled =
        payPal.enabled && WcsLocales.getLocalizedMessage(payPal.localizedMessage, locale)
      return payPalIsEnabled
    },
    klarnaDescription() {
      const klarnaIsEnabled =
        klarna.onSiteMessagingEnabled &&
        WcsLocales.getLocalizedMessage(klarna.localizedMessage, locale)
      return klarnaIsEnabled
    },
    afterpayDescription() {
      const afterpayIsEnabled =
        afterpay.enabled && WcsLocales.getLocalizedMessage(afterpay.localizedMessage, locale)
      return afterpayIsEnabled
    },
  },
}
